module.exports = __webpack_public_path__ + "static/media/default-profile-photo2.86c664d4.svg";